import { ConvertDto } from 'common/api/autogenerated/trading-gateway';

import { CreateOrderParams } from 'common/popups/ConfirmLimitOrder/ConfirmLimitOrder.modal';
import { GroupsHashMap } from 'common/types';

import { ActionTypes } from './useTracking.hook';

export type SmartlookParamsType =
  | CreateOrderParams
  | ConvertDto
  | { id: string }
  | { group: keyof GroupsHashMap | null }
  | { futuresSelectedOption: string };

export enum SmartlookEventEnum {
  'marketOrder:created' = 'marketOrder:created',
  'limitOrder:created' = 'limitOrder:created',
  'limitOrder:edited' = 'limitOrder:edited',
  'exchange:created' = 'exchange:created',
  'buy-crypto:created' = 'buy-crypto:created',
  'not-enough-liquidity:otc' = 'not-enough-liquidity:otc',
  'not-enough-liquidity:spot' = 'not-enough-liquidity:spot',
  'not-enough-liquidity:futures' = 'not-enough-liquidity:futures',
  'deposit:method:choose' = 'deposit:method:choose',
  'exchange:tutorial:open' = 'exchange:tutorial:open',
  'exchange:tutorial:close' = 'exchange:tutorial:close',
  'buy-crypto:tutorial:open' = 'buy-crypto:tutorial:open',
  'buy-crypto:tutorial:close' = 'buy-crypto:tutorial:close',
  'layout:sidebar:collapse' = 'layout:sidebar:collapse',
  'layout:sidebar:expand' = 'layout:sidebar:expand',
  'home:coins:click-show' = 'home:coins:click-show',
  'home:coins:select-category' = 'home:coins:select-category',
  'home:coins:click-reset' = 'home:coins:click-reset',
  'home:coins:click-sortby' = 'home:coins:click-sortby',
  'home:coins:click-more-filters:mobile' = 'home:coins:click-more-filters:mobile',
  'home:coins:click-more-filters:desktop' = 'home:coins:click-more-filters:desktop',

  // 85523 TEMP CODE TO SHOW TEMPORARY UNAVAILABLE ERROR
  'futures:temp-unavailable:chosen:exec-type' = 'futures:temp-unavailable:chosen:exec-type',
  'futures:temp-unavailable:chosen:margin-type' = 'futures:temp-unavailable:chosen:margin-type',
  'futures:temp-unavailable:chosen:position-mode' = 'futures:temp-unavailable:chosen:position-mode',
  'futures:temp-unavailable:chosen:tpsl-partial' = 'futures:temp-unavailable:chosen:tpsl-partial',
  'not-found-cta:open-order:spot' = 'not-found-cta:open-order:spot',
  'not-found-cta:open-order:futures' = 'not-found-cta:open-order:futures',
}

export type SmartlookEventTypes = keyof typeof SmartlookEventEnum;

export class SmartlookEventTracker {
  process(action: ActionTypes, data?: SmartlookParamsType) {
    if (!window.smartlook) return;

    if (action in SmartlookEventEnum) {
      window.smartlook('track', action, data);
    }
  }
}
